import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Arthroscopy() {
  useEffect(() => {
    document.title = "Arthroscopy (Keyhole Surgery) | Viksha Health Care";
    const newMetaDescription =
      "Arthroscopy (keyhole surgery) at Viksha Health Care. Learn when arthroscopy is advised, how it works, and what recovery typically involves.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Arthroscopy (Keyhole Surgery)</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Arthroscopy-Keyhole-Surgery.avif" />
        </div>
        <div className="textareaofser">
          <h1>Arthroscopy (Keyhole Surgery)</h1>

          <p>
            Arthroscopy, commonly known as keyhole surgery, is a minimally
            invasive procedure used to diagnose and treat problems inside a
            joint. Small incisions and a tiny camera allow the surgeon to view
            the joint clearly and perform treatment with minimal tissue damage.
          </p>

          <p>
            This technique is often used for joints such as the knee, shoulder,
            ankle, elbow, and wrist. Arthroscopy usually results in less pain,
            smaller scars, and faster recovery compared to traditional open
            surgery.
          </p>

          <h5>Conditions Treated with Arthroscopy</h5>
          <ul>
            <li>Ligament injuries (such as ACL tears)</li>
            <li>Meniscus tears in the knee</li>
            <li>Cartilage damage</li>
            <li>Shoulder impingement and rotator cuff problems</li>
            <li>Loose bone or cartilage fragments in a joint</li>
            <li>Joint inflammation or stiffness</li>
          </ul>

          <h5>How the Procedure Is Performed</h5>
          <p>
            During arthroscopy, a small camera called an arthroscope is inserted
            into the joint through a tiny incision. Surgical instruments are
            introduced through additional small openings to repair or remove
            damaged tissue.
          </p>

          <h5>Benefits of Arthroscopy</h5>
          <ul>
            <li>Smaller incisions and minimal scarring</li>
            <li>Less pain after surgery</li>
            <li>Reduced risk of infection</li>
            <li>Shorter hospital stay in many cases</li>
            <li>Faster recovery and return to daily activities</li>
          </ul>

          <h5>Recovery After Arthroscopy</h5>
          <p>
            Recovery time depends on the type of procedure performed and the
            joint involved. Physiotherapy is often recommended to restore
            strength, movement, and joint function. Most patients are able to
            resume normal activities gradually.
          </p>

          <h5>When Is Arthroscopy Recommended?</h5>
          <p>
            Arthroscopy may be advised when joint pain, instability, or limited
            movement does not improve with non-surgical treatment, or when
            imaging shows damage that can be repaired through minimally invasive
            techniques.
          </p>

          <p>
            Arthroscopy offers an effective and less invasive option for
            managing many joint conditions, helping patients return to an active
            and pain-free life.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(Arthroscopy);
